<template>
  <div id="container" class="flex_one">
    <div class="list_box full_layout">
      <div class="list_left_box">
        <div class="tac">
          <template>
            <div class="seach_list_left flex items-center rangeBox">
              <span class="flex_1 rangeTitle">{{ $t('base.PriceRange') }}</span>
              <div class="flex items-center">
                <el-input class="login_ipt range_ipt" size="mini" :placeholder="$t('base.Min')" v-model="minPrice.Value" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" @change="setPriceRange()">
                  <span slot="prefix" style="padding-right: 12px;">USD</span>
                </el-input>
                <span class="short ">-</span>
                <el-input class="login_ipt range_ipt" size="mini" :placeholder="$t('base.Max')" v-model="maxPrice.Value" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" @change="setPriceRange()">
                  <span slot="prefix">USD</span>
                </el-input>
              </div>
            </div>
          </template>
          <el-collapse v-model="activeNames" class="seach_list_left">
            <el-collapse-item :name="Number(1)">
              <template slot="title">
                {{ $t('base.category') }}
              </template>
              <div v-if="Category.length>0">
                <div class="CategoryList" v-for="(item,index) in Category" :key="index" :class="firstCategoryId==item.id?'on':'on'">
                  <div class="CategoryFirstTitle">{{categoryI18n(item.EnName,'name')}}</div>
                  <div class="CategoryFirstDetail" v-for="(it,i) in item.children" :key="i" :class="[secondCategoryId==it.id?'on':'',secondCategoryIdarray[i]['isType']?'ov':'']">
                    <div class="CategorySecTitle" @click="isCategory(it.id,'s',i)">{{categoryI18n(it.EnName,'name')}}</div>
                    <ul class="CategorySecDetail">
                      <li v-for="(res,j) in it.children" :key="j" :class="thirdCategoryId==res.id?'on':''">
                        <router-link :to="{path:'/market',query:{type:'category',f:res.Fid,s:res.Sid,t:res.id,key:searchKey}}">{{categoryI18n(res.EnName,'name')}}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item :name="Number(index+2)" v-for='(item,index) in checkList' :key='index'>
              <template slot="title">
                <span class="flex_1">{{categoryI18n(item.Property.EnName,'key')}}</span>
                <template v-if="item.PropertyKeyValues.length<=2&&item.PropertyKeyValues[0].EnName=='No'">
                    <el-switch v-model="sportslist[item.Property.ControlName]" active-color="#5F6DAE" @change='checkboxChange'></el-switch>
                </template>
              </template>
              <template v-if="item.PropertyKeyValues.length>2&&item.PropertyKeyValues[0].EnName!='No'">
                <div>
                  <el-checkbox-group v-model="sportslist[item.Property.ControlName]" @change='checkboxChange'>
                    <div v-for="(res,i) in item.PropertyKeyValues" :key="i">
                      <el-checkbox :label="res" v-show="isSports[item.Property.EnName]?item.PropertyKeyValues.length:(i<5)">
                        {{categoryI18n(res.EnName,'value',item.Property.ControlName)}}
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                  <div class="catalogue_a_color" v-if="item.PropertyKeyValues.length>5" @click="setIsSports(item.Property.EnName)">
                    {{ isSports[item.Property.EnName] ? '' : $t('base.seeAll') }}</div>
              </div>
              </template>
              
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="list_right_box">
        <div class="all_item">
          <div class="flex_layout_between">
            <div class="seller_tab">
              <span class="" v-if='searchKey!=null' :class="isSort == 0 ? 'on' : ''" @click="SellerSort(0)">{{$t('base.bestMatch')}}</span>
              <span class="" :class="isSort == 1 ? 'on' : ''" @click="SellerSort(1)">{{Status=='1'?$t('enum.endingSoonest'):$t('enum.endingRecently')}}</span>
              <span class="sort_price" :class="isSort == 2 ? 'on' : ''" @click="SellerSort(2)">
                {{ $t('base.price') }}
                <em class="up_arr" :class="isPrice ? 'up' : ''"></em>
                <em class="up_down" :class="!isPrice && isPrice != null ? 'up' : ''"></em>
              </span>
              <span class="" :class="isSort == 3 ? 'on' : ''" @click="SellerSort(3)">{{ $t('base.newly') }}</span>
              <span v-if='isAuction' class="" :class="isSort == 4 ? 'on' : ''" @click="SellerSort(4)">{{ $t('base.mostBids') }}</span>
            </div>
            <div class="seller_select">
              <el-select class="select_seller all_listings" v-model="listings" @change="getSelect('listings')">
                <el-option v-for="(item) in all_listings" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select class="select_seller all_status" v-model="Status" @change="getSelect('Status')">
                <el-option v-for="(item) in all_Status" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-if="isGraded" class="select_seller" v-model="Graded" @change="getSelect('Graded')">
                <el-option v-for="(item) in all_Graded" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="saveResults">
            <div><strong>{{TotalCount.toLocaleString()}}</strong> {{$t('base.Results')}}</div>
            <div class="saveBox" v-if="!saveSearchData&&searchKey">
              <span class="Saved" v-if="userInfo" @click="setSearchKey()">{{$t('base.Savethissearch')}}</span>
              <router-link class="Saved" v-if="!userInfo" :to="{path:'/login'}">{{$t('base.Savethissearch')}}</router-link>
              <div class="topover">
                <div class="topTitle">{{$t('title.TrySavethissearch')}}</div>
                {{$t('alert.TrySavethissearchalert')}}
              </div>
            </div>
            <div class="saveBox isSave" v-if="saveSearchData&&searchKey&&userInfo">
              <span class="Saved" @click="delAlerts(saveSearchData)">{{$t('base.saved')}}</span>
              <div class="topover" v-if="isShowSave" v-loading="ShowSaveLoading">
                <span class="Save_close" @click="isShowSave=!isShowSave"></span>
                <p class="save_p">{{$t('alert.savedalert')}} ({{yesNotice}}/{{searchCount}})</p>
                <div class="save_btn">
                  <router-link :to="{path:'/mycardhobby/search'}">{{$t('base.SeeMore')}}</router-link>
                  <span @click="setAlerts()">{{$t('base.TurnOnEmailAlerts')}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-skeleton :count="12" animated class="thousand_layout skull" :loading="loading">
          <template slot="template">
            <list-skeleton />
          </template>
          <template>
            <goods-list class="thousand_layout" :StatusNum="Status" :list="list" type="search" />
          </template>
        </el-skeleton>
        <list-pagination class="full_layout" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!ifData" />
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
        <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo, resetCategory, getCategory,priceExchange,GetWorldUSD, CookiesCategory } from "@/api/public";
import GoodsList from "@/components/list/goods";
import ListPagination from "@/components/listpagination";
import NOTN from "@/components/notnull.vue";
import ListSkeleton from "@/components/skeleton.vue";
import FZF from "@/components/404.vue";
export default {
  name: "index",
  components: { GoodsList, ListPagination, NOTN, FZF, ListSkeleton },
  data() {
    return {
      ShowSaveLoading: false,
      yesNotice: 0,
      searchCount: 0,
      isShowSave: false,
      userInfo: '',
      saveSearchData: '',
      searchKey: '',
      resultTpye: '',
      sort: 'EffectiveTimeStamp',
      sortType: 'asc',
      Category: [],
      expandedKeys: [],
      thirdCategoryIdarray: [],
      firstCategoryId: '',
      secondCategoryId: '',
      secondCategoryIdarray: [],
      thirdCategoryId: "",
      activeNames: [1],
      defaultactive: '',
      checkList: [],
      sportslist: '',
      radiosportslist: '',
      sportsKeys: this.$enumInfo.PropertyList,
      isSports: '',
      loading: false,
      isType: '',
      isSportsId: '',
      //auction拍卖：2、buy it now一口价：1->ByWay accept offers可议价：1->Bargain Status是selling出售中1、sold出售的-2{ "Key": "ByWay", "Value": "" }, { "Key": "Bargain", "Value": "" },
      buway: [],
      CategoryKeys: [{ "Key": "Status", "Value": "1" }],
      minPrice:{"Key":"MinPrice","Value":''},
      maxPrice:{"Key":"MaxPrice","Value":''},
      SeachJson: [],
      ifData: false,
      list: {},
      defaultProps: {
        children: "children",
        label: "EnName",
      },
      isSort: 1,
      isPrice: null,
      isAuction: true, // 是否拍卖
      isGraded: false, // 是否评分
      listings: "0",
      Status: '1',
      isTabSold: {
        'selling': 1,
        'sold': 3
      },
      searchInsert: {
        ImgUrl: 'https://images.cardhobby.com/noimg.jpg',
        FindKey: '',
        FindValue: '',
        ShowKey: '',
        ShowValue: '',
        MemberId: ''
      },
      Graded: "0",
      all_Sort: this.$enumInfo.searchSort,
      all_listings: this.$enumInfo.listings,
      all_Status: this.$enumInfo.status,
      all_Graded: this.$enumInfo.graded,
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
    };
  },
  watch: {
    '$route': 'getPath'
  },
  created() {
    GetWorldUSD()
    this.getPath()
    let that = this;
    this.userInfo = getInfo();
    this.isType = this.$route.query.type;
    this.getCategoryList();
    // console.log('this.Status',this.Status)

    /**默认展开Sport Cards**/
    //that.getCategorykey('4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de');
  },
  mounted() {
    this.$root.$on("newSearch", val => {
      this.searchKey = val || null;
    })
    this.getCategoryList();
  },
  methods: {

    /**
     * 获取路由参数并初始化搜索相关数据
     * 根据不同的类型(GameComic/Sports/Graded/Card/category)处理搜索逻辑
     * 设置搜索关键字、用户信息、分类信息等
     * 触发搜索事件并获取相应的分类数据
     * @method getPath
     * @returns {void}
     */
    getPath() {
      this.saveSearchData = '';
      this.searchKey = this.$route.query.key || null;
      let that = this;
      this.userInfo = getInfo();
      this.isType = this.$route.query.type;
      this.getCategoryList();

      //@todo
      //let typeName='like,auction,buy'
      //console.log(typeName.indexOf(this.isType),'this.isType')
      // if(typeName.indexOf(this.isType)>-1){
      //     that.getType(this.isType)
      // }else{
      //   this.$root.$emit("newSearch", this.searchKey);
      //   this.isSportsId = this.$route.query.id;
      //   this.getCategorykey(this.$route.query.f, this.$route.query.s, this.$route.query.t);
        
      //   if(this.isType == "search"){
      //       this.saveSearch()
      //   }else{
      //     this.getThirdCategoryId(this.$route.query.t);
      //   }
      // }



      if (this.isType == "GameComic" || this.isType == "Sports" || this.isType == "Graded" || this.isType == "Card" || this.isType == "category" || this.isType == null) {
        this.$root.$emit("newSearch", this.searchKey);
        this.isSportsId = this.$route.query.id;
        this.getCategorykey(this.$route.query.f, this.$route.query.s, this.$route.query.t);
        this.getThirdCategoryId(this.$route.query.t);
      } else {
        if (this.isType != "search") {
          that.getType(this.isType)
          // that.expandedKeys = ['dee8e93d-bf0d-46d7-a817-45db58756940']
          // that.thirdCategoryIdarray = ['dee8e93d-bf0d-46d7-a817-45db58756940']
          // that.thirdCategoryId = ""
        } else {
          this.$root.$emit("newSearch", this.searchKey);
          // if (!this.$route.query.t) {
          //   that.expandedKeys = ['dee8e93d-bf0d-46d7-a817-45db58756940']
          //   that.thirdCategoryIdarray = ['dee8e93d-bf0d-46d7-a817-45db58756940']
          //   that.thirdCategoryId = ""
          //   this.$route.query.t = 'dee8e93d-bf0d-46d7-a817-45db58756940'
          // }
          this.getCategorykey(this.$route.query.f, this.$route.query.s, this.$route.query.t);
          if (this.$route.query.t) {
            this.getThirdCategoryId(this.$route.query.t);
          } else {
            this.saveSearch()
          }

        }
        //that.getCategorykey('dee8e93d-bf0d-46d7-a817-45db58756940', 'dee8e93d-bf0d-46d7-a817-45db58756940');
      }
    },
    Loading(val) {
      this.loading = val
    },
    /**
     * [getCategoryList 获取类目]
     * @auther qian
     */
    /**
     * 获取商品分类列表数据
     * 从 Cookie 中获取分类数据,并处理成二级分类数组
     * @method getCategoryList
     * @description 获取商品分类列表,将分类数据处理成包含id、英文名称和是否选中状态的数组
     * @returns {void} 无返回值,直接修改组件的 Category 和 secondCategoryIdarray 数据
     */
    getCategoryList() {
      this.Loading(true)
      let that = this
      let array = [];
      let fun = function(res) {
        that.Category = res;
        let s = that.$route.query.s
        res.map(item => {
          item.children.map(it => {
            array.push({ 'id': it.id, 'EnName': it.EnName, isType: (s && s == it.id ? true : false) })
          })
        })
        that.secondCategoryIdarray = array
      }
      CookiesCategory('get', 'cardCategory', 'shop', fun)
    },
    // 获取三级类目下的属性 属性：sportslist, 是否多于8条：isSports
    /**
     * 根据三级分类ID获取属性键值对数据
     * @param {string|number} val - 三级分类ID
     * @description 
     * - 通过API获取指定三级分类的属性数据
     * - 处理体育卡片(Sports)和评级卡片(Graded)的特殊显示逻辑
     * - 根据isType判断是否需要加载保存的搜索条件
     * - 更新组件的筛选列表、显示状态和单选列表数据
     */
    getThirdCategoryId(val) {
      let that = this;
      this.$get(this.$interface.GetKeyValueByThirdCategoryId, { 'thirdCategoryId': val, 'size': '99' }).then(res => {
        if (res.Result != 0) {
          let data = res.Data
          this.checkList = data
          let newArray = {};
          let radionewArray = {};
          let isShow = {};
          let sportItem = "";
          res.Data.map(item => {
            newArray[item.Property.ControlName] = []
            if(item.PropertyKeyValues.length<=2&&item.PropertyKeyValues[0].EnName=='No'){
              newArray[item.Property.ControlName] = false
            }
            isShow[item.Property.ControlName] = false
            //console.log(item.Property.ControlName,'item.Property.ControlName')
            //console.log(item,'item.Property.ControlName')
            if (item.Property.ControlName == 'Sports') {
              sportItem = item.PropertyKeyValues;
            }
          })
          
          //console.log(this.isType,'newArray',this.isSportsId,sportItem)
          //筛选 单卡 sports
          
          this.activeNames = [1]
          if(this.isType&&this.isType!='search'){
            if(Array.isArray(newArray[this.isType])){
              isShow[this.isType] = true;
              try{
                let newSportArray= sportItem.filter(item=>item.EnName==this.isSportsId)
                if(newSportArray&&newSportArray.length>0){
                    newArray[this.isType].push(newSportArray[0])
                }
                var v = 1
                for (var key in newArray) {
                  v++
                  if(key==this.isType){
                    this.activeNames = [1, v]
                  }
                }
              }catch(e){

              }
            }else{
              newArray[this.isType]=this.isSportsId&&this.isSportsId=='Yes'?true:false
            }
          }
          //console.log(isShow,newArray,radionewArray,'newArray')
          that.isSports = isShow
          that.sportslist = newArray
          that.radiosportslist = radionewArray;
          console.log(newArray,'newArray')
          // 根据isType的值
          var isSearch = ''
          if (that.isType == "search") {
            isSearch = window.localStorage.getItem('saveSearch') != null ? window.localStorage.getItem('saveSearch') : '';
          }
          if (isSearch) {
            //console.log(1,'isSearch')
            that.saveSearch()
          } else {
            //console.log(2,'isSearch')
            that.checkboxChange();
          }
        }
      })
    },
    /**
     * 设置价格范围
     * 该方法用于更新搜索条件中的最大价格和最小价格
     * 如果MaxPrice/MinPrice已存在则更新，不存在则添加
     * @throws {Error} 捕获并打印可能的错误
     */
    setPriceRange() {
      let that = this
      const isMaxPrice=that.SeachJson.findIndex(item=>item.Key==='MaxPrice');
      const isMinPrice=that.SeachJson.findIndex(item=>item.Key==='MinPrice');
      const minPrice=that.minPrice.Value
      const maxPrice=that.maxPrice.Value
      try{

        if(Number(minPrice)>=Number(maxPrice)){
          that.maxPrice.Value=''
        }
      }catch(e){}
      //console.log(isMaxPrice,'isMaxPrice',isMinPrice,'isMinPrice')
      try{
        if(isMinPrice>-1){
          that.SeachJson[isMinPrice]=that.minPrice
        }else{
          that.SeachJson.push(that.minPrice)
        }
        if(isMaxPrice>-1){
          that.SeachJson[isMaxPrice]=that.maxPrice
        }else{
          that.SeachJson.push(that.maxPrice)
        }
        that.getDetailList();
      }catch(e){
        console.log(e, 'PriceRange')
      }
    },
    /**
     * 转换价格范围对象的货币值
     * @param {Array} obj - 包含价格范围的对象数组，每个对象需包含Key和Value属性
     * @returns {string} - 返回转换后的对象数组的JSON字符串
     * @description 
     * 1. 查找对象数组中Key为'MinPrice'和'MaxPrice'的项
     * 2. 对找到的项调用priceExchange函数转换其Value值
     * 3. 如果转换过程中发生错误，返回原始对象的JSON字符串
     * 4. 该函数主要用于处理价格范围的货币兑换
     */
    setPriceRangeExchange(obj) {
      let that = this
      let oldObj=JSON.parse(JSON.stringify(obj))
        const isMaxPrice=oldObj.findIndex(item=>item.Key==='MaxPrice');
        const isMinPrice=oldObj.findIndex(item=>item.Key==='MinPrice');
        try{
        if(isMinPrice>-1){
          let minPrice=oldObj[isMinPrice].Value
          if(minPrice!=''){
            oldObj[isMinPrice].Value=priceExchange(minPrice)
          }
        }
        if(isMaxPrice>-1){
          let maxPrice=oldObj[isMaxPrice].Value
          if(maxPrice!=''){
            oldObj[isMaxPrice].Value=priceExchange(maxPrice)
          }
        }
        
        return JSON.stringify(oldObj)
      }catch(e){
        console.log(e, 'PriceRange')
        return JSON.stringify(obj)
      }
    },
    /**
     * 获取商品详情列表
     * 
     * 该方法用于根据搜索条件获取商品列表数据，支持分页和排序
     * 
     * @function
     * @async
     * @returns {Promise<void>} 无直接返回值，但会更新组件内的列表数据和分页信息
     * @throws {Error} 当API请求失败时会捕获错误并处理
     * 
     * @description
     * 1. 处理搜索条件(SeachJson)，包括价格区间转换
     * 2. 构造请求参数(pageIndex, pageSize等)
     * 3. 发送POST请求获取商品列表
     * 4. 处理响应数据，更新列表和分页信息
     * 5. 处理无数据情况(ifData)
     * 6. 捕获并处理请求错误
     */
    getDetailList() {
    //sort=EffectiveTimeStamp&sortType=asc
      let that = this;

      that.Loading(true)
      let SeachJson = JSON.stringify(that.SeachJson);
      try{
        SeachJson = that.setPriceRangeExchange(that.SeachJson)
      }catch(e){}
      //console.log(that.SeachJson, 'that.SeachJson')
      //let sn = window.localStorage.getItem('sn') != null ? window.localStorage.getItem('sn') : '';
      // if (sn != '') {
      //   this.searchKey = sn
      //   this.isSort = 0
      // } else {
      //   this.searchKey = null
      // }
      let data = { userId: '', pageIndex: that.pi, pageSize: that.ps, searchJson: SeachJson, sort: that.sort, sortType: that.sortType }
      if (that.userInfo != null) {
        data.userId = that.userInfo.MappingUserId
      }
      if(that.searchKey){
        data.searchKey=that.searchKey
      }
      let url=this.$interface.OnSaleSearchCommodity
      if(that.Status==2){
        url=this.$interface.SoldSearchCommodity
      }
      console.log(url,'url')
      this.$post(url, data).then(res => {
        if (res.result != 0) {
          var data = res.data;
          that.pi = parseInt(data.PageIndex)
          that.TotalCount = parseInt(data.TotalCount)
          that.list = data.PagedMarketItemList;
          if (that.list.length == 0) {
            this.ifData = true;
          } else {
            this.ifData = false;
          }
        } else {
          this.ifData = true;
        }
        that.resultTpye = res.result
        that.Loading(false)
      }).catch(error => {

        this.ifData = false;
        this.Loading(false)
      })
    },

    /**
     * 保存搜索条件并处理搜索数据
     * 
     * 1. 从localStorage获取保存的搜索条件
     * 2. 根据搜索条件反向查询并选中对应属性
     * 3. 展开包含搜索结果的属性分类
     * 4. 处理特殊搜索条件(价格方式、价格范围等)
     * 5. 过滤一级/二级类目ID
     * 6. 更新搜索参数并触发列表查询
     */
    saveSearch() {
      let that = this
      let data = window.localStorage.getItem('saveSearch') != null ? window.localStorage.getItem('saveSearch') : '';
      that.saveSearchData = JSON.parse(data)
      data = JSON.parse(data)
      data = JSON.parse(data.FindValue)
      // console.log(data,'data')
      // console.log(that.checkList,'checkList')
      // 根据获取到的SeachJson反向查询对应的属性并选中
      that.checkList.map(item => {
        data.map(res => {
          if (item.Property.ControlName == res.Key) {
              console.log(item.Property.ControlName,'item.Property.ControlName')
              console.log(item.Property.ControlName,res,res.Value==true)
              if(res.Value===true||res.Value==='Yes'){
                that.sportslist[item.Property.ControlName]=true
              }else{
                item.PropertyKeyValues.map(it => {
                  if (it.EnName == res.Value) {
                    //console.log(it.EnName,res.Value,that.sportslist[item.Property.ControlName],item.Property.ControlName,'item.Property.ControlName')
                    that.sportslist[item.Property.ControlName].push(it)
                  }
                })
              }
          }
        })
      })

      //console.log(that.sportslist,' res.Key')
      // 展开对应属性
      that.activeNames = [1]
      var v = 1
      for (var prop in that.sportslist) {
        v++
        if (that.sportslist[prop].length > 0) {
          that.activeNames.push(v)
        }
      }

      // 去除SeachJson中的一级类目id和二级类目id
      let setArr = []
      data.map(res => {
        if (res.Key == 'FirstCategoryId' || res.Key == 'SecondCategoryId') {
          setArr.push(res)
        }
        if (res.Key == 'ByWay') {
          if (res.Value == '1') { that.listings = '1' } //一口价
          if (res.Value == '2') { that.listings = '2' } //竞拍
        }
        if (res.Key == 'Bargain') {
          if (res.Value == '1') { that.listings = '3' } //Make Offer
        }
        if(res.Key=='MinPrice'){
          that.minPrice.Value=res.Value
        }
        if(res.Key=='MaxPrice'){
          that.maxPrice.Value=res.Value
        }
      })
      data = data.filter(res => { return !(setArr.indexOf(res) > -1) }).concat(setArr.filter(res => { return !(data.indexOf(res) > -1) }))
      //console.log(data,'data')

      that.SeachJson = data
      that.getDetailList();
    },
    /**
     * 设置搜索关键字并保存搜索条件
     * 
     * 该方法用于构建搜索条件的显示值(ShowValue)和搜索参数(SeachJson)，
     * 包括分类、商品模式、属性和价格范围等信息，并将搜索条件保存到服务器。
     * 
     * 主要功能：
     * 1. 构建分类层级显示路径
     * 2. 处理商品模式类型显示
     * 3. 处理特殊属性显示（如Graded、Rookie等）
     * 4. 处理价格范围显示
     * 5. 重组搜索参数JSON
     * 6. 发送保存请求到服务器
     * 
     * @returns {void}
     */
    setSearchKey() {
      let that = this
      let ShowValue = 'Trading Cards'
      let SeachJson = JSON.parse(JSON.stringify(that.SeachJson));
      let isTrd = false
      that.searchInsert.ImgUrl='https://images.cardhobby.com/noimg.jpg'
      if (that.list.length > 0) {
        that.searchInsert.ImgUrl = that.list[0].TitImg
      }
      if (that.Category) {
        that.firstCategoryId = that.Category[0].id
      }

      //类别分类名称
      if (that.secondCategoryId) {
        var Category = that.Category[0]
        Category.children.map(res => {
          if (res.id == that.secondCategoryId) {
            ShowValue += '/' + res.EnName

            if (!that.thirdCategoryId) {
              that.thirdCategoryId = res.children[0].id
            }

            res.children.map(item => {
              if (item.id == that.thirdCategoryId) {
                ShowValue += '/' + item.EnName
              }
            })
          }
        })
      }
      //商品模式名称
      if (that.listings > 0) {
        var listings = ''
        if (that.listings == 1) {
          listings = 'Buy It Now'
        }
        if (that.listings == 2) {
          listings = 'Auction'
        }
        if (that.listings == 3) {
          listings = 'Best Offer'
        }
        if(listings){
          ShowValue += ' · ' + listings
        }
        
      }
      //属性名称
      for (var prop in that.sportslist) {
        //console.log(that.sportslist,prop,that.sportslist[prop],'prop')
        if (that.sportslist[prop].length > 0) {
          var propvalue = ''
          that.sportslist[prop].map(res => {
            // if (prop == 'Graded' || prop == 'SerialNumbered' || prop == 'Rookie' || prop == 'Auto') {
            //   if (that.sportslist[prop].length == 2) {
            //     propvalue += ''
            //   } else {
            //     propvalue += that.sportslist[prop].EnName == 'No' ? '' : '/' + (prop == 'SerialNumbered' ? 'Serial Numbered' : prop)
            //   }
            // } else {
            //   propvalue += '/' + res.EnName
            // }
            
            propvalue += '/' + res.EnName
          })
          propvalue = propvalue.replace("/", " · ")
          ShowValue += propvalue
        }else if(typeof(that.sportslist[prop])=='boolean'){
          var propvalue = ''
          if(that.sportslist[prop]){
            propvalue += '/' + (prop == 'SerialNumbered' ? 'Serial Numbered' : prop)
          }else{
            propvalue += ''
          }
          propvalue = propvalue.replace("/", " · ")
          ShowValue += propvalue
        }
          
      }

      try{
        const minPrice=that.minPrice.Value
        const maxPrice=that.maxPrice.Value
        let priceRange=''
        if(minPrice!=''&&maxPrice!=''){
          priceRange=`USD ${minPrice} - USD ${maxPrice}`
        }else if(minPrice!=''){
          priceRange=`USD ${minPrice} - `
        }else if(maxPrice!=''){
          priceRange=` - USD ${maxPrice}`
        }
        if(priceRange){
          ShowValue += ' · ' + priceRange
        }
      }catch(e){}

      /**
       * [changeSeachJson 根据属性名称重组SeachJson]
       * @param  obj   [SeachJson]
       * @param  value [属性名称]
       * @auther qian
       */
      // var changeSeachJson = function(obj, value) {
      //   let name = value
      //   let data = obj
      //   let setArr = []
      //   data.map((res, index) => {
      //     if (res.Key == name) {
      //       setArr.push(res)
      //       console.log(setArr,'setArr',res)
      //     }
      //     if (res.Key == 'Status') {
      //       res.Value = 1
      //     }
      //     if (res.Key == 'ThirdCategoryId') {
      //       isTrd = true
      //     }
      //   })
      //   // 去除指定内容，两个数组补集
      //   if (setArr.length >= 2) {
      //     return data.filter(res => { return !(setArr.indexOf(res) > -1) }).concat(setArr.filter(res => { return !(data.indexOf(res) > -1) }))
      //   }
      //   return data
      // }
      // SeachJson = changeSeachJson(SeachJson, 'Graded')
      // SeachJson = changeSeachJson(SeachJson, 'Rookie')
      // SeachJson = changeSeachJson(SeachJson, 'Auto')
      // SeachJson = changeSeachJson(SeachJson, 'SerialNumbered')
      if (that.firstCategoryId) {
        SeachJson.push({ "Key": "FirstCategoryId", "Value": that.firstCategoryId })
      }
      if (that.secondCategoryId) {
        SeachJson.push({ "Key": "SecondCategoryId", "Value": that.secondCategoryId })

        // if (!isTrd) {
        //   SeachJson.push({ "Key": "ThirdCategoryId", "Value": that.thirdCategoryId })
        // }
      }
      try{
        SeachJson.map(res=>{
          if(res.Value===true){
            res.Value='Yes'
          }
        })
      }catch(e){}
      //console.log(SeachJson,'setArr')
      that.searchInsert.FindKey = that.searchInsert.ShowKey = that.searchKey || ''
      that.searchInsert.FindValue = JSON.stringify(SeachJson)
      that.searchInsert.ShowValue = ShowValue
      that.searchInsert.MemberId = that.userInfo.MappingUserId
      that.searchInsert.MemberSource = that.userInfo.MemberSource
      //console.log(that.searchInsert,'that.searchInsert')
      that.Loading(true)
      that.$post(that.$interface.SearchInsert, that.searchInsert).then(res => {
        if (res.Result != 0) {
          that.Loading(false)
          that.$message({
            type: 'success',
            duration: 1000,
            message: 'Saved Successfully!'
          });
          window.localStorage.setItem("saveSearch", JSON.stringify(res.Data))
          that.saveSearchData = res.Data
          that.setSaveSearchAlert()
        }
      })
    },
    /**
     * [delAlerts 删除已保存的搜索条件]
     * @param  obj [saveSearchData]
     * @auther qian
     */
    /**
     * 删除搜索记录
     * @param {Object} obj - 包含要删除的搜索记录信息
     * @description 根据用户ID和记录ID删除对应的搜索记录,删除成功后清空搜索数据
     * @example
     * delAlerts({_id: 'recordId'})
     */
    delAlerts(obj) {
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId, Id: obj._id }
      that.loading = true
      that.$post(that.$interface.SearchDelete, data).then(res => {
        if (res.Result != 0) {
          that.saveSearchData = ''
          that.loading = false
        } else {
          that.$message({
            type: 'error',
            duration: 2000,
            message: res.Msg
          });
        }
      })
    },
    /**
     * [setSaveSearchAlert 获取允许通知的最大条目和当前设置的通知的条目]
     * @auther qian
     */
    /**
     * 设置保存搜索提醒
     * 获取搜索设置并更新搜索计数,同时获取搜索页面数据
     * 统计已开启通知的数量,更新通知状态
     * 切换保存显示状态
     */
    setSaveSearchAlert() {
      let that = this
      that.ShowSaveLoading = true
      that.$get(that.$interface.SearchGetSetting, '').then(res => {
        if (res.Result != 0) {
          that.searchCount = res.Data.SearchCount
          let data = { MemberId: that.userInfo.MappingUserId, PageIndex: 1, PageSize: res.Data.SearchCount }
          that.$get(that.$interface.SearchPage, data).then(item => {
            if (item.Result != 0) {
              var yesNotice = 0
              item.Data.map(item => {
                if (item.IsNotice) {
                  yesNotice++
                }
              })
              that.yesNotice = yesNotice
            }
            that.ShowSaveLoading = false
          })
        }
      })
      that.isShowSave = !that.isShowSave
    },
    /**
     * [setAlerts 点击修改允许通知时的弹框]
     * @auther qian
     */
    setAlerts() {
      let that = this;
      let emailNum = that.yesNotice ? that.yesNotice : 0
      let obj = that.saveSearchData
      if (!obj.IsNotice == true) {
        if (emailNum >= that.searchCount) {
          var html = "<div style='text-align: center;'>You can subscribe to email alerts for up to " + that.searchCount + " saved searches.(" + emailNum + "/" + that.searchCount + ")</div>"
          that.$confirm(html, that.$t('base.hint'), {
            dangerouslyUseHTMLString: true,
            lockScroll: false,
            showConfirmButton: false,
            cancelButtonText: that.$t('base.cancel'),
          }).then(() => {}).catch(() => {});
        } else {
          that.setNotice()
        }
      } else {
        that.setNotice()
      }
    },
    /**
     * [setNotice 点击修改通知]
     * @auther qian
     */
    /**
     * 设置通知状态
     * 更新用户搜索记录的通知状态,并同步到本地存储
     * @method setNotice
     * @private
     * @returns {void}
     * @description 通过接口更新通知状态,成功后更新本地数据并刷新界面,失败则显示错误提示
     */
    setNotice() {
      let that = this;
      let obj = that.saveSearchData
      let data = { MemberId: that.userInfo.MappingUserId, Id: obj._id, Notice: !obj.IsNotice }
      that.ShowSaveLoading = true
      that.$post(that.$interface.SetNotice, data).then(res => {
        if (res.Result != 0) {
          that.saveSearchData.IsNotice = !that.saveSearchData.IsNotice
          window.localStorage.setItem("saveSearch", JSON.stringify(that.saveSearchData))
          that.isShowSave=!that.isShowSave
        } else {
          that.$message({
            type: 'error',
            duration: 2000,
            message: res.Msg
          });
        }
        that.ShowSaveLoading = false
      })
    },
    /**
     * [getCategorykey 设置默认展开]
     * @param  f [商品类别一级id]
     * @param  s [商品类别二级id]
     * @param  t [商品类别三级id]
     * @auther qian
     */
    /**
     * 设置分类选择的展开状态和分类ID
     * @param {string|number} f - 一级分类ID
     * @param {string|number} s - 二级分类ID  
     * @param {string|number} t - 三级分类ID
     * @description 根据传入的分类ID设置展开的节点和选中的分类ID状态
     */
    getCategorykey(f, s, t) {
      let that = this;
      let fid = f;
      let sid = s;
      let tid = t;
      this.expandedKeys = fid ? [fid] : []
      this.thirdCategoryIdarray = sid ? [sid] : []

      this.firstCategoryId = fid || ''
      this.secondCategoryId = sid || ''
      this.thirdCategoryId = tid || ''
      // if (fid != undefined && sid != undefined) {
      //   that.expandedKeys = [fid]
      //   that.thirdCategoryId = sid
      //   that.thirdCategoryIdarray = [sid]
      // }
    },

    /**
     * 切换分类选中状态并更新分类ID
     * @param {number|string} id - 分类ID
     * @param {string} type - 分类类型,s表示二级分类
     * @param {number} i - 数组索引
     */
    isCategory(id, type, i) {
      let that = this;
      //this.secondCategoryIdarray[i]=!this.secondCategoryIdarray[i]
      if (type == 's') {
        that.secondCategoryIdarray.map(res => {
          if (res.id == id) {
            res.isType = !res.isType
          }
        })
        that.secondCategoryId = id || ''
      }
    },
    // 获取属性
    /**
     * 处理复选框变更事件，更新搜索条件并获取列表数据
     * 主要功能:
     * - 处理 Graded Card 类型的特殊逻辑
     * - 整合搜索条件(运动类型、分类、购买方式等)
     * - 构建最终的搜索参数 SeachJson
     * - 触发列表数据刷新
     * @private
     */
    checkboxChange() {
      let that = this;
      let newCategoryKeys = that.CategoryKeys
      let newbuway = that.buway
      let newArray = [];

      // if (this.isType == 'Graded' && this.isSportsId == 'Graded Card') {
      //   let radiolist = that.checkList;
      //   let radioObj = '';
      //   radiolist.map(res => {
      //     if (res.Property.ControlName == 'Graded') {
      //       radioObj = res.PropertyKeyValues
      //     }
      //   })
      //   that.sportslist.Graded = [radioObj[1]]
      // }
      //console.log(that.sportslist,'that.sportslist')
      let oldArray = that.sportslist
      for (var key in oldArray) {
            //console.log(key,oldArray[key],typeof(oldArray[key]),'oldArray')
        if (oldArray[key].length > 0) {
          oldArray[key].map(res => {
            //console.log(key,res,'key,res')
            newArray.push({ "Key": key, "Value": res.EnName })
          })
        }else if(typeof(oldArray[key])=='boolean'){
          if(oldArray[key]){
            newArray.push({ "Key": key, "Value": 'Yes' })
          }
        }
      }
      
      that.SeachJson = [...newArray, ...newCategoryKeys, ...newbuway]
      if (this.isType == 'GameComic') {
        that.SeachJson=[...that.SeachJson, { "Key": this.isType, "Value": this.isSportsId }]
      }

      that.saveSearchData = ''
      if (that.thirdCategoryId) {
        that.SeachJson = [...that.SeachJson, { "Key": "ThirdCategoryId", "Value": that.thirdCategoryId }]
      }

      that.getDetailList();
    },
    // 左边栏 隐藏显示
    /**
     * 设置运动项目选择状态
     * @param {string|number} val - 运动项目的标识值
     * @description 切换指定运动项目的选中状态。如果该项目未初始化则设置为选中,否则切换其状态
     */
    setIsSports(val) {
      let that = this;
      if (!that.isSports[val]) {
        that.$set(that.isSports, val, true);
      } else {
        that.isSports[val] = !that.isSports[val];
      }
    },
    // select 筛选
    /**
     * 处理不同类型的选择变更
     * @param {string} val - 选择类型，可选值: 'listings'/'Status'/'Graded'
     * @description
     * - listings: 处理商品上架方式的选择(普通/拍卖/议价)
     * - Status: 处理商品状态的选择(在售/已售)
     * - Graded: 处理商品评级状态的选择(无评级/已评级/未评级)
     * 选择变更后会更新相关状态并触发复选框变更事件
     */
    getSelect(val) {
      let that = this;

      this.Loading(true)
      that.pi = 1;
      switch (val) {
        case 'listings':
          that.buway = [];
          if (that.listings == 2 || that.listings == 1) {
            if (that.listings == 2) {
              that.isAuction = true
            } else {
              that.isAuction = false
            }

            that.buway.push({ "Key": "ByWay", "Value": that.listings })
            if(that.listings==1){
              that.buway.push({ "Key": "Bargain", "Value": 0 })
            }
          } else if (that.listings == 3) {
            that.buway.push({ "Key": "Bargain", "Value": 1 })
          } else if (that.listings == 0) {

            that.isAuction = true
            that.buway = [];
          }
          break;
        case 'Status':
          
          // if (that.Status == 0) {
          //   that.CategoryKeys = [{ "Key": "Status", "Value": 1 }]
          // } else if (that.Status == 1) {
          //   that.CategoryKeys = [{ "Key": "Status", "Value": 1 }]
          // } else if (that.Status == 2) {
          //   that.CategoryKeys = [{ "Key": "Status", "Value": -2 }]
          // }

          if (that.Status != 2) {
            that.SellerSort(that.isTabSold.selling, 1)
            that.CategoryKeys = [{ "Key": "Status", "Value": 1 }]
          } else {
            that.SellerSort(that.isTabSold.sold, 1)
            that.CategoryKeys = [{ "Key": "Status", "Value": -2 }]
            //that.SellerSort(3)
          }
          break;
        case 'Graded':
          let radiolist = that.checkList;
          let radioObj = '';
          radiolist.map(res => {
            if (res.Property.ControlName == 'Graded') {
              radioObj = res.PropertyKeyValues
            }
          })
          if (that.Graded == 0) {
            that.sportslist.Graded = []
          } else if (that.Graded == 1) {
            that.sportslist.Graded = radioObj[1]
          } else if (that.Graded == 2) {
            that.sportslist.Graded = radioObj[0]
          }
          break;

      }
      that.checkboxChange()
    },
    // tab 排序 type 1=>不走获取列表的方法
    /**
     * 处理卖家列表排序逻辑
     * @param {number} val - 排序类型值 (0:默认, 1:时间, 2:价格, 3:库存, 4:一口价)
     * @param {number} type - 是否需要重新获取列表数据 (1:不重新获取)
     * @description 根据不同的排序类型设置相应的排序参数,包括排序字段、排序方式等,
     * 同时处理价格排序的正倒序切换,以及一口价的特殊筛选逻辑
     */
    SellerSort(val, type) {
      let that = this;
      that.Loading(true)
      that.pi = 1;
      that.isSort = val;
      if (that.Status == '1') {
        that.isTabSold.selling = val
      } else {
        that.isTabSold.sold = val
      }
      if (val == 0) {} {
        that.sort = '';
        that.sortType = '';
      }
      if (val == 1) {
        that.sort = that.all_Sort[0]['val'];
        if (that.Status == '1') {
          that.sortType = that.all_Sort[0]['sortType'];
        } else {
          that.sortType = 'DESC'
        }
      }
      if (val == 3) {
        that.sort = that.all_Sort[3]['val']
        that.sortType = that.all_Sort[3]['sortType']
      }
      if (val == 2) {
        that.sort = that.all_Sort[1]['val'];
        that.isPrice = !that.isPrice;
        if (that.isPrice) {

          that.sortType = that.all_Sort[1]['sortType'];
        } else {
          that.sortType = that.all_Sort[2]['sortType'];
        }

      } else {
        that.isPrice = null;
      }
      if (val == 4) {
        let isByWay = 0
        that.sort = that.all_Sort[4]['val'];
        that.sortType = that.all_Sort[4]['sortType'];
        that.buway = []
        that.buway.push({ "Key": "ByWay", "Value": '2' })
        that.listings = '2'
        that.SeachJson.map(res => {
          if (res.Key == 'ByWay') {
            isByWay++;
            res.Value = '2'
          }
        })
        if (isByWay == 0) {
          that.SeachJson = [...that.SeachJson, ...that.buway]
        }
      }
      if (type != 1) {
        this.getDetailList();
      }

    },
    //获取 排序属性 除"category" "Sports"
    /**
     * 根据选择的类型更新搜索条件和列表数据
     * @param {string} val - 搜索类型，可选值: 'like'(猜你喜欢), 'auction'(拍卖), 'buy'(一口价)
     * @description 
     * - 'like': 根据搜索关键字设置排序方式
     * - 'auction': 设置拍卖交易方式
     * - 'buy': 设置一口价交易方式
     * 更新后重置分类、筛选条件并重新获取列表数据
     */
    getType(val) {
      let that = this;
      that.buway = []
      // 最新发布，猜你喜欢
      if (val == "like") {
        // if (that.searchKey != '' && that.searchKey != null) {
        //   that.isSort = 0;
        //   that.sort = ""
        //   that.sortType = ""
        // } else {
        //   that.isSort = 3;
        //   that.sort = that.all_Sort[3]['val']
        //   that.sortType = that.all_Sort[3]['sortType'];
        // }
        
          that.isSort = 1;
          that.sort = that.all_Sort[0]['val']
          that.sortType = that.all_Sort[0]['sortType'];
        // 拍卖
      } else if (val == 'auction') {
        that.listings = '2'
        that.buway.push({ "Key": "ByWay", "Value": '2' })
        // 一口价
      } else if (val == 'buy') {
        that.listings = '1'
        that.buway.push({ "Key": "ByWay", "Value": '1' })
        that.buway.push({ "Key": "Bargain", "Value": 0 })
      }
      that.thirdCategoryId = ""
      that.expandedKeys = []
      this.activeNames = [1]
      that.checkList = []
      this.pi = 1;
      that.SeachJson = [...that.CategoryKeys, ...that.buway]
      that.getDetailList();
    },
    // Category list
    /**
     * 处理树形结构选择变更事件
     * @param {Object} val - 选中的节点数据，包含 Sid(父级ID)、id(当前ID)、Fid(一级ID)
     * @description 根据选中节点更新分类状态并进行路由跳转
     * - 当选中三级分类时(有Sid)：更新分类ID并跳转到市场页面
     * - 当选中其他级别时：仅展开对应节点
     */
    treeChange(val) {
      let that = this;

      if (val.Sid) {
        //that.Loading(true)
        that.isType = ''
        that.thirdCategoryId = val.id
        that.thirdCategoryIdarray = [val.id]
        that.expandedKeys = [val.Sid]

        this.$router.push({
          path: '/market',
          query: { type: 'category', p: val.Sid, s: val.id }
        })
        //that.getThirdCategoryId(val.id);
      } else {
        that.expandedKeys = [val.Fid]

      }
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getDetailList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getDetailList();
    },
    categoryI18n(obj, type, val) {
      //return obj
      try{
      if (type == 'key') {
        return this.$t('categoryKey.' + obj.replace(/\s*/g, ""))
      }
      if (type == 'value') {
        if (val == 'Year' || val == 'Manufacturer' || val == 'Features' || val == 'ProfessionalGrader' || val == 'Rarity') {
          return obj
        }
        return this.$t('categoryValue.' + obj.replace(/\s*/g, ""))
      }
      if (type == 'name') {
        return this.$t('categoryName.' + obj.replace(/\s*/g, ""))
      }
      }catch(e){}
    }
  },
  //离开页面后清除
  destroyed() {
    window.localStorage.removeItem("sn")
    window.localStorage.removeItem("st")
    // window.localStorage.removeItem("saveSearch")
  }
};

</script>
<style scoped>
@import "../../../static/css/search.css";

.list_left_box{
  flex:1;
  width: auto;
}
.list_right_box{
  padding-left: 20px;
}
.list_right_box .all_item {
  border: none;
  margin-top: 12px;
  margin-bottom: 0px;
}
.rangeBox{
  margin-top: 16px;
}
.rangeBox .short{
  margin: 0 4px;
}
.rangeTitle{
  font-weight: 700;
}

.seller_tab {
  display: flex;
  justify-content: flex-start;
  height: 36px;
  margin-top: 6px;
}

.seller_tab span {
  padding: 9px 12px;
  position: relative;
  border: 1px solid #e0e0e0;
  line-height: normal;
  cursor: pointer;
}

.seller_tab span+span {
  border-left: none;
}

.seller_tab span:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.seller_tab span:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.seller_tab .sort_price {
  padding-right: 22px !important;
}

.seller_tab .sort_price em {
  top: 18px;
  right: 3px;
}

.seller_tab .sort_price .up_arr {
  top: 12px;
}

.seller_tab span.on {
  color: #fff;
  background-color: #5F6DAE;
}

.list_left_box {
  display: flex;
  flex-direction: column;
}

.saveResults {
  display: flex;
  height: 50px;
  align-items: center;
  /*      position: fixed;
    left: calc( 50vw - 600px );
    width: 268px;
    background: #fff;
    bottom: 0;
    height: 50px;
    align-items: center;*/
}

.saveBox {
  position: relative;
  cursor: pointer;
  color: #5f6dae;
  font-size: 16px;
  margin-left: 32px;
}

.saveBox .Saved {
  background: url(../../../static/images/Sevad.png) no-repeat;
  background-size: contain;
  padding-left: 20px;
  color: #5f6dae;
}

.saveBox .topover {
  display: none;
  position: absolute;
  padding: 8px 12px;
  background-color: #5f6dae;
  color: #fff;
  width: 256px;
  right: 0;
  top: -130px;
  border-radius: 4px;
  line-height: 1.4;
  font-size: 14px;
  z-index: 99;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.10);
}

.saveBox .topover .topTitle {
  font-size: 16px;
  font-weight: 700;
}

.saveBox .topover:before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #5f6dae;
  transform: rotate(45deg);
  position: absolute;
  bottom: -3px;
  right: 10px;
}

.saveBox:hover .topover {
  display: block;
}

.isSave .Saved {
  background-image: url(../../../static/images/Sevad_fill.png);
}

.isSave .topover {
  display: block;
  background-color: #fff;
  color: #333;
  width: 205px;
  top: -100px;
}

.isSave .topover:before {
  background-color: #fff;
}

.save_p {
  width: 90%;
  margin-bottom: 5px;
}

.save_btn {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

.Save_close {
  background: url(../../../static/images/icon/icon_close.svg) center no-repeat;
  background-size: contain;
  width: 12px;
  height: 12px;
  position: absolute;
  position: absolute;
  right: 13px;
  top: 12px;
  z-index: 99;
}

.save_btn>span,
.save_btn>a {
  cursor: pointer;
  color: #5F6DAE;
}

.save_btn>span:hover,
.save_btn>a:hover {
  text-decoration: underline;
}
.catalogue_a_color{
  cursor: pointer;
}


/*.seller_tab span:hover, .seller_tab span.on{
  color: #5F6DAE;
    border:initial;
}*/

</style>



// WEBPACK FOOTER //
// src/pages/list/search.vue